import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { CalendarioSpettacolo } from '../../../../shared/interface';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-calendario-spettacolo-backoffice',
  templateUrl: './calendario-spettacolo-backoffice.component.html',
  styleUrl: './calendario-spettacolo-backoffice.component.css'
})
export class CalendarioSpettacoloBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService, private datePipe: DatePipe) {}
  
  @ViewChild(ConfirmPopup) delete!: ConfirmPopup;

  @Input() date_calendario: CalendarioSpettacolo[] = [];
  @Output() data = new EventEmitter<CalendarioSpettacolo[]>();
  
  data_calendario?: CalendarioSpettacolo;  

  add: boolean = false;
  edit: boolean = false;

  formCalendario!: FormGroup;  

  ngOnInit(): void {

    this.formCalendario = new FormGroup({
      data: new FormControl(null, Validators.required),
      orario: new FormControl(null),
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenAdd() {
    this.add = true;
    this.formCalendario.reset();
    this.formCalendario.markAsPristine();
    this.formCalendario.markAsUntouched();
  }

  onAdd(reset: boolean) {

    let calendario: any = {
      data: this.formCalendario.get('data')?.value ? this.datePipe.transform(this.formCalendario.get('data')?.value, 'yyyy-MM-dd') || null : null,
      orario: this.formCalendario.get('orario')?.value ? this.datePipe.transform(new Date(this.formCalendario.get('orario')?.value), 'HH:mm') || null : null,
    }

    this.date_calendario.push(calendario);
    this.data.emit(this.date_calendario);

    if (reset) {
      this.formCalendario.reset();
      this.formCalendario.markAsPristine()
      this.formCalendario.markAsUntouched();
    } else {      
      this.onCloseModal();
    }

  }

  onOpenEdit(calendario: CalendarioSpettacolo) {

    this.data_calendario = calendario;

    this.formCalendario.setValue({
      data: new Date(calendario.data || ''),
      orario: new Date(this.datePipe.transform(new Date(), 'yyyy-MM-dd') + " " + calendario.orario),
    })
    
    this.edit = true;
  }

  onEdit() {

    this.date_calendario.filter(calendario => calendario == this.data_calendario).map(calendario => {
      calendario.data = this.formCalendario.get('data')?.value ? this.datePipe.transform(this.formCalendario.get('data')?.value, 'yyyy-MM-dd') || null : null;
      calendario.orario = this.formCalendario.get('orario')?.value ? this.datePipe.transform(this.formCalendario.get('orario')?.value, 'HH:mm') || null : null;
    });

    this.data.emit(this.date_calendario);
    this.onCloseModal()

  }

  onOpenDelete(event: Event, calendario: CalendarioSpettacolo, index: number) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare la data calendario dallo spettacolo?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteCalendarioSpettacolo(calendario.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.date_calendario.splice(index, 1)
            this.apiService.message("success", "Eliminazione", "La data del calendario è stato eliminata con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.delete.accept();
  }

  onAnnullaDelete() {
    this.delete.reject();
  }

  onCloseModal() {    
    this.add = false;
    this.edit = false;
  }
    
}
